export default __webpack_public_path__ + "0fb24386f3e0f94c61fff09569cbbff7.svg";